import { render, staticRenderFns } from "./shareDraw.vue?vue&type=template&id=81bf9c9c&scoped=true&"
import script from "./shareDraw.vue?vue&type=script&lang=js&"
export * from "./shareDraw.vue?vue&type=script&lang=js&"
import style0 from "./shareDraw.vue?vue&type=style&index=0&id=81bf9c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bf9c9c",
  null
  
)

export default component.exports